import type { GetPickersResponse } from './pickers'

export const getPickersResponse: GetPickersResponse = {
  pickers: [
    {
      id: 'recommended_variants',
      label: 'Our goodest finds',
      items: [
        {
          label: 'Lowest price',
          productId: 'e19e0bad-531b-4bcc-af24-d6a066359f76',
          link: {
            type: 'internal',
            name: 'product',
            pattern: '/:locale/p/:slugV2/:uuid',
            params: {
              id: '152419',
              slug: 'tested-and-certified-used-iphone-12-pro-128-gb-graphite-unlocked',
              slugV2: 'iphone-12-pro-128-gb-graphite-unlocked',
              uuid: 'e19e0bad-531b-4bcc-af24-d6a066359f76',
              locale: 'en-us',
            },
            query: {},
            hash: { l: '12' },
            href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-128-gb-graphite-unlocked/e19e0bad-531b-4bcc-af24-d6a066359f76#l=12',
          },
          available: true,
          selected: false,
          icon: 'IconEyes',
          price: { amount: '405.43', currency: 'USD' },
          trackingValue: 'lowest_price',
          emphasis: 'info',
          grade: { name: 'Fair', value: 12 },
        },
        {
          label: 'Top shelf',
          productId: '9461bdac-68b3-4e0a-94f2-ebe58168c0d9',
          link: {
            type: 'internal',
            name: 'product',
            pattern: '/:locale/p/:slugV2/:uuid',
            params: {
              id: '152461',
              slug: 'tested-and-certified-used-iphone-12-pro-512-gb-pacific-blue-unlocked',
              slugV2: 'iphone-12-pro-512-gb-pacific-blue-unlocked',
              uuid: '9461bdac-68b3-4e0a-94f2-ebe58168c0d9',
              locale: 'en-us',
            },
            query: {},
            hash: { l: '10' },
            href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-512-gb-pacific-blue-unlocked/9461bdac-68b3-4e0a-94f2-ebe58168c0d9#l=10',
          },
          available: true,
          selected: false,
          icon: 'IconSparkles',
          price: { amount: '631.83', currency: 'USD' },
          trackingValue: 'top_shelf',
          emphasis: 'accent',
          grade: { name: 'Excellent', value: 10 },
        },
      ],
      trackingId: 'master_picker',
    },
    {
      id: 'grades',
      label: 'Condition',
      items: [
        {
          label: 'Fair',
          productId: 'a88d8ee0-4955-4565-98bb-f46465253890',
          link: {
            type: 'internal',
            name: 'product',
            pattern: '/:locale/p/:slugV2/:uuid',
            params: {
              id: '152447',
              slug: 'tested-and-certified-used-iphone-12-pro-128-gb-pacific-blue-unlocked',
              slugV2: 'iphone-12-pro-128-gb-pacific-blue-unlocked',
              uuid: 'a88d8ee0-4955-4565-98bb-f46465253890',
              locale: 'en-us',
            },
            query: {},
            hash: { l: '12' },
            href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-128-gb-pacific-blue-unlocked/a88d8ee0-4955-4565-98bb-f46465253890#l=12',
          },
          available: true,
          selected: true,
          price: { amount: '432.67', currency: 'USD' },
          trackingValue: '12',
          grade: { name: 'Fair', value: 12 },
        },
        {
          label: 'Good',
          productId: 'a88d8ee0-4955-4565-98bb-f46465253890',
          link: {
            type: 'internal',
            name: 'product',
            pattern: '/:locale/p/:slugV2/:uuid',
            params: {
              id: '152447',
              slug: 'tested-and-certified-used-iphone-12-pro-128-gb-pacific-blue-unlocked',
              slugV2: 'iphone-12-pro-128-gb-pacific-blue-unlocked',
              uuid: 'a88d8ee0-4955-4565-98bb-f46465253890',
              locale: 'en-us',
            },
            query: {},
            hash: { l: '11' },
            href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-128-gb-pacific-blue-unlocked/a88d8ee0-4955-4565-98bb-f46465253890#l=11',
          },
          available: true,
          selected: false,
          price: { amount: '530.18', currency: 'USD' },
          trackingValue: '11',
          grade: { name: 'Good', value: 11 },
        },
        {
          label: 'Excellent',
          productId: 'a88d8ee0-4955-4565-98bb-f46465253890',
          link: {
            type: 'internal',
            name: 'product',
            pattern: '/:locale/p/:slugV2/:uuid',
            params: {
              id: '152447',
              slug: 'tested-and-certified-used-iphone-12-pro-128-gb-pacific-blue-unlocked',
              slugV2: 'iphone-12-pro-128-gb-pacific-blue-unlocked',
              uuid: 'a88d8ee0-4955-4565-98bb-f46465253890',
              locale: 'en-us',
            },
            query: {},
            hash: { l: '10' },
            href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-128-gb-pacific-blue-unlocked/a88d8ee0-4955-4565-98bb-f46465253890#l=10',
          },
          available: true,
          selected: false,
          price: { amount: '561.66', currency: 'USD' },
          trackingValue: '10',
          grade: { name: 'Excellent', value: 10 },
        },
      ],
      trackingId: 'grade_picker',
    },
    {
      id: 'battery',
      label: 'ProductPage.Pickers.Battery.Label',
      items: [
        {
          label: 'ProductPage.Pickers.Battery.Standard',
          productId: 'f597a490-5e4c-450c-88a8-14be4d46f9c1',
          link: {
            type: 'internal',
            name: 'product',
            pattern: '/:locale/p/:slugV2/:uuid',
            params: {
              id: '512418',
              slug: 'iphone-13-pro-128-go-bleu-alpin-debloque-tout-operateur-pas-cher',
              slugV2: 'iphone-13-pro-128-go-bleu-alpin-debloque-tout-operateur',
              uuid: 'f597a490-5e4c-450c-88a8-14be4d46f9c1',
              locale: 'fr-fr',
            },
            query: {},
            hash: {
              l: '11',
            },
            href: 'https://www.backmarket.fr/fr-fr/p/iphone-13-pro-128-go-bleu-alpin-debloque-tout-operateur/f597a490-5e4c-450c-88a8-14be4d46f9c1#l=11',
          },
          available: true,
          selected: true,
          price: {
            amount: '598',
            currency: 'EUR',
          },
          trackingValue: '0',
          grade: {
            name: 'Très bon état',
            value: 11,
          },
        },
        {
          label: 'ProductPage.Pickers.Battery.NewBattery',
          productId: 'f597a490-5e4c-450c-88a8-14be4d46f9c1',
          link: {
            type: 'internal',
            name: 'product',
            pattern: '/:locale/p/:slugV2/:uuid',
            params: {
              id: '512418',
              slug: 'iphone-13-pro-128-go-bleu-alpin-debloque-tout-operateur-pas-cher',
              slugV2: 'iphone-13-pro-128-go-bleu-alpin-debloque-tout-operateur',
              uuid: 'f597a490-5e4c-450c-88a8-14be4d46f9c1',
              locale: 'fr-fr',
            },
            query: {},
            hash: {
              l: '11',
              offerType: '7',
            },
            href: 'https://www.backmarket.fr/fr-fr/p/iphone-13-pro-128-go-bleu-alpin-debloque-tout-operateur/f597a490-5e4c-450c-88a8-14be4d46f9c1#l=11&offerType=7',
          },
          available: true,
          selected: false,
          price: {
            amount: '743',
            currency: 'EUR',
          },
          trackingValue: '7',
          grade: {
            name: 'Très bon état',
            value: 11,
          },
        },
      ],
      trackingId: 'battery_picker',
    },
    {
      id: 'storage',
      label: 'Storage (GB)',
      items: [
        {
          label: '128 GB',
          productId: 'a88d8ee0-4955-4565-98bb-f46465253890',
          link: {
            type: 'internal',
            name: 'product',
            pattern: '/:locale/p/:slugV2/:uuid',
            params: {
              id: '152447',
              slug: 'tested-and-certified-used-iphone-12-pro-128-gb-pacific-blue-unlocked',
              slugV2: 'iphone-12-pro-128-gb-pacific-blue-unlocked',
              uuid: 'a88d8ee0-4955-4565-98bb-f46465253890',
              locale: 'en-us',
            },
            query: {},
            hash: { l: '12' },
            href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-128-gb-pacific-blue-unlocked/a88d8ee0-4955-4565-98bb-f46465253890#l=12',
          },
          available: true,
          selected: true,
          trackingValue: '128',
          grade: { name: 'Fair', value: 12 },
        },
        {
          label: '256 GB',
          productId: '75e0c14c-918e-4822-8f52-934274fb1b9f',
          link: {
            type: 'internal',
            name: 'product',
            pattern: '/:locale/p/:slugV2/:uuid',
            params: {
              id: '152464',
              slug: 'tested-and-certified-used-iphone-12-pro-256-gb-pacific-blue-unlocked',
              slugV2: 'iphone-12-pro-256-gb-pacific-blue-unlocked',
              uuid: '75e0c14c-918e-4822-8f52-934274fb1b9f',
              locale: 'en-us',
            },
            query: {},
            hash: { l: '12' },
            href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-256-gb-pacific-blue-unlocked/75e0c14c-918e-4822-8f52-934274fb1b9f#l=12',
          },
          available: true,
          selected: false,
          trackingValue: '256',
          grade: { name: 'Fair', value: 12 },
        },
        {
          label: '512 GB',
          productId: '9461bdac-68b3-4e0a-94f2-ebe58168c0d9',
          link: {
            type: 'internal',
            name: 'product',
            pattern: '/:locale/p/:slugV2/:uuid',
            params: {
              id: '152461',
              slug: 'tested-and-certified-used-iphone-12-pro-512-gb-pacific-blue-unlocked',
              slugV2: 'iphone-12-pro-512-gb-pacific-blue-unlocked',
              uuid: '9461bdac-68b3-4e0a-94f2-ebe58168c0d9',
              locale: 'en-us',
            },
            query: {},
            hash: { l: '12' },
            href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-512-gb-pacific-blue-unlocked/9461bdac-68b3-4e0a-94f2-ebe58168c0d9#l=12',
          },
          available: true,
          selected: false,
          trackingValue: '512',
          grade: { name: 'Fair', value: 12 },
        },
      ],
      trackingId: 'storage_picker',
    },
    {
      id: 'color',
      label: 'Color',
      items: [
        {
          label: 'Pacific Blue',
          productId: 'a88d8ee0-4955-4565-98bb-f46465253890',
          link: {
            type: 'internal',
            name: 'product',
            pattern: '/:locale/p/:slugV2/:uuid',
            params: {
              id: '152447',
              slug: 'tested-and-certified-used-iphone-12-pro-128-gb-pacific-blue-unlocked',
              slugV2: 'iphone-12-pro-128-gb-pacific-blue-unlocked',
              uuid: 'a88d8ee0-4955-4565-98bb-f46465253890',
              locale: 'en-us',
            },
            query: {},
            hash: { l: '12' },
            href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-128-gb-pacific-blue-unlocked/a88d8ee0-4955-4565-98bb-f46465253890#l=12',
          },
          available: true,
          selected: true,
          color: '#2E4755',
          trackingValue: 'Pacific Blue',
          grade: { name: 'Fair', value: 12 },
        },
        {
          label: 'Graphite',
          productId: 'e19e0bad-531b-4bcc-af24-d6a066359f76',
          link: {
            type: 'internal',
            name: 'product',
            pattern: '/:locale/p/:slugV2/:uuid',
            params: {
              id: '152419',
              slug: 'tested-and-certified-used-iphone-12-pro-128-gb-graphite-unlocked',
              slugV2: 'iphone-12-pro-128-gb-graphite-unlocked',
              uuid: 'e19e0bad-531b-4bcc-af24-d6a066359f76',
              locale: 'en-us',
            },
            query: {},
            hash: { l: '12' },
            href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-128-gb-graphite-unlocked/e19e0bad-531b-4bcc-af24-d6a066359f76#l=12',
          },
          available: true,
          selected: false,
          color: '#504F4B',
          trackingValue: 'Graphite',
          grade: { name: 'Fair', value: 12 },
        },
        {
          label: 'Gold',
          productId: 'a8fdff83-1d6d-4012-9cb1-96912d785f5b',
          link: {
            type: 'internal',
            name: 'product',
            pattern: '/:locale/p/:slugV2/:uuid',
            params: {
              id: '152413',
              slug: 'tested-and-certified-used-iphone-12-pro-128-gb-gold-unlocked',
              slugV2: 'iphone-12-pro-128-gb-gold-unlocked',
              uuid: 'a8fdff83-1d6d-4012-9cb1-96912d785f5b',
              locale: 'en-us',
            },
            query: {},
            hash: { l: '12' },
            href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-128-gb-gold-unlocked/a8fdff83-1d6d-4012-9cb1-96912d785f5b#l=12',
          },
          available: true,
          selected: false,
          color: '#FEEFDA',
          trackingValue: 'Gold',
          grade: { name: 'Fair', value: 12 },
        },
        {
          label: 'Silver',
          productId: 'df590b98-8484-4b21-b784-99b1538db7c0',
          link: {
            type: 'internal',
            name: 'product',
            pattern: '/:locale/p/:slugV2/:uuid',
            params: {
              id: '152470',
              slug: 'tested-and-certified-used-iphone-12-pro-128-gb-silver-unlocked',
              slugV2: 'iphone-12-pro-128-gb-silver-unlocked',
              uuid: 'df590b98-8484-4b21-b784-99b1538db7c0',
              locale: 'en-us',
            },
            query: {},
            hash: { l: '12' },
            href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-128-gb-silver-unlocked/df590b98-8484-4b21-b784-99b1538db7c0#l=12',
          },
          available: true,
          selected: false,
          color: '#F4F5F0',
          trackingValue: 'Silver',
          grade: { name: 'Fair', value: 12 },
        },
      ],
      trackingId: 'color_picker',
    },
  ],
}
